import { useStatQuery } from '@famly/stat_use-stat-query';
import { KinderConnectCaptureChildren } from './kinder-connect-capture-children.query';
/**
 * Fetches every child a site could record attendance for -- including future starters -- along
 * with whether KinderConnect TWC capture is currently collected for them. Used to build the
 * capture settings modal's searchable, per-child toggle list.
 *
 * @param options - Apollo query options; must include `variables: {siteId}`.
 * @returns The query result, with `data.attendance.childCheckins.kinderConnectCaptureChildren`
 * holding the list once loaded.
 */
export function useKinderConnectCaptureChildrenQuery(options) {
    // No manual cache update needed: the settings mutation returns matching KinderConnectCaptureChild
    // objects (same id, same fields) that Apollo merges into this query's cache automatically.
    return useStatQuery(KinderConnectCaptureChildren, options);
}
